/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {map} from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {APP_CONFIG} from '../app.config';
import {VehicleDirectionDefinition} from "../model/VehicleDirectionDefinition";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class VehicleDirectionDefinitionService {

  private readonly baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = inject(APP_CONFIG).baseUrl + '/api/vehicledirectiondefinitions';
  }


  getAll(): Observable<VehicleDirectionDefinition[]> {
    const url = `${this.baseUrl}/all`;
    return this.http.get(url, httpOptions).pipe(
      map(crashObject => crashObject as VehicleDirectionDefinition[]));
  }

  updateVehicleDirectionById(vehicleDirection: VehicleDirectionDefinition): Observable<VehicleDirectionDefinition>{
    const id = vehicleDirection.vehicleDirectionDefinitionId;
    const url = `${this.baseUrl}/${id}`;

    return this.http.put(url,vehicleDirection,httpOptions).pipe(
      map(vehicleDirection => vehicleDirection as VehicleDirectionDefinition));
  }

  addVehicleDirection(vehicleDirection: VehicleDirectionDefinition): Observable<VehicleDirectionDefinition>{
    const url = `${this.baseUrl}`;

    return this.http.post(url,vehicleDirection,httpOptions).pipe(
      map(vehicleDirection => vehicleDirection as VehicleDirectionDefinition));
  }
}
